import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './assets/fonts/fonts.css';

import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));


// Add meta tag to force light mode
const metaTag = document.createElement('meta');
metaTag.name = 'color-scheme';
metaTag.content = 'light';
document.head.appendChild(metaTag);

// Render the app using `root.render()`
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);